module.exports = __webpack_public_path__ + "media/images/emblems/Denens-coat_of_arms-6bcbcac03ebade6851619028d43c5c9e.svg";